import { render } from "./ProductMultiSelect.vue?vue&type=template&id=2f7b63a0&ts=true"
import script from "./ProductMultiSelect.vue?vue&type=script&lang=ts"
export * from "./ProductMultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__